import { lazy } from 'react';

import { renderRoutesFromArray } from './renderRoutesFromArray';

const DailyTipper = lazy(() => import('../screens/main/daily-tipper'));
const DailyTipperQuestion = lazy(() => import('../screens/main/daily-tipper/question'));
const DailyTipperResult = lazy(() => import('../screens/main/daily-tipper/result-dialog'));
const YearCongrats = lazy(() => import('../screens/main/daily-tipper/year-congrats'));
const DtAchievements = lazy(() => import('../screens/main/daily-tipper/achievements'));

const routeDefinitions = [
  {
    path: '/daily-tipper',
    element: <DailyTipper />,
    children: [
      {
        path: 'result',
        element: <DailyTipperResult />,
      },
      {
        path: 'achievements',
        element: <DtAchievements />,
      },
      {
        path: 'year-congrats',
        element: <YearCongrats />,
      },
    ],
  },
  {
    path: '/daily-tipper-question/:questionId/',
    element: <DailyTipperQuestion />,
  },
  {
    path: '/daily-tipper-question/:questionId/completed',
    element: <DailyTipperQuestion />,
  },
];

const dailyTipperRoutes = renderRoutesFromArray(routeDefinitions);

export default dailyTipperRoutes;
